import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loginUser } from "../../redux/actions/auth";
import * as RB from "react-bootstrap";
import image from "../../dm-logo.svg";

// get our fontawesome imports
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faKey, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LoginPage = ({ loginUser, history }) => {
    const [state, setState] = useState({
        username: "",
        password: "",
    });
    const [errInfo, setErrInfo] = useState("");
    const handleChange = (event) => {
        const { name, value } = event.target;
        setState({ ...state, [name]: value });
    };

    const login = async (event) => {
        setErrInfo("");
        event.preventDefault();
        const { username, password } = state;
        try {
            const response = await loginUser(username, password);
            history.push("/investigatescreen");
        } catch (obj) {
            if (obj.status === 401) setErrInfo("Неверный логин или пароль");
            else setErrInfo("Сервис недоступен");
        }
    };

    return (
        <div>
            <RB.Container fluid="true">
                <RB.Row
                    className="align-items-center justify-content-center"
                    style={{
                        paddingTop: "4rem",
                        marginLeft: 0,
                        marginRight: 0,
                    }}
                >
                    <RB.Jumbotron
                        className="align-items-center justify-content-center"
                        style={{
                            backgroundColor: "#e9ecef73",
                            padding: "2rem 2rem",
                        }}
                    >
                        <RB.Row
                            className="justify-content-center"
                            style={{
                                margin: "1rem 0rem",
                            }}
                        >
                            <RB.Figure>
                                <RB.Image src={image} width="200px" />
                            </RB.Figure>
                        </RB.Row>
                        <RB.Form onSubmit={login}>
                            <RB.Form.Group>
                                <RB.InputGroup>
                                    <RB.InputGroup.Prepend>
                                        <RB.InputGroup.Text
                                            style={{
                                                backgroundColor: "#dee2e6",
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faUser}
                                                fixedWidth
                                            />
                                        </RB.InputGroup.Text>
                                    </RB.InputGroup.Prepend>
                                    <RB.Form.Control
                                        type="text"
                                        name="username"
                                        value={state.username}
                                        onChange={handleChange}
                                        placeholder="Имя пользователя"
                                    />
                                </RB.InputGroup>
                            </RB.Form.Group>
                            <RB.Form.Group>
                                <RB.InputGroup>
                                    <RB.InputGroup.Prepend>
                                        <RB.InputGroup.Text
                                            style={{
                                                backgroundColor: "#dee2e6",
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faKey}
                                                fixedWidth
                                            />
                                        </RB.InputGroup.Text>
                                    </RB.InputGroup.Prepend>
                                    <RB.Form.Control
                                        type="password"
                                        name="password"
                                        value={state.password}
                                        onChange={handleChange}
                                        placeholder="Пароль"
                                    />
                                </RB.InputGroup>
                            </RB.Form.Group>
                            {/* <RB.Alert
                                variant="danger"
                                style={{ fontSize: "0.8rem" }}
                            >
                                Неверный логин или пароль
                            </RB.Alert> */}
                            {errInfo != "" && (
                                <div
                                    id="login-error"
                                    style={{
                                        color: "rgb(240, 40, 73)",
                                        fontSize: "0.9rem",
                                        marginBottom: "-1.55rem",
                                        marginTop: "-0.5rem",
                                    }}
                                >
                                    {errInfo}
                                </div>
                            )}
                            <RB.Button
                                variant="outline-primary"
                                block
                                type="submit"
                                style={{
                                    marginTop: "2rem",
                                }}
                            >
                                Войти
                            </RB.Button>
                        </RB.Form>
                    </RB.Jumbotron>
                </RB.Row>
            </RB.Container>
        </div>
    );
};

LoginPage.propTypes = {
    loginUser: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
    loginUser,
};

export default connect(null, mapDispatchToProps)(LoginPage);
